import { MUTATION_TYPES } from './types';
import { initialState } from './state';

export default {
  [MUTATION_TYPES.RESET](state) {
    Object.assign(state, initialState());
  },
  [MUTATION_TYPES.SET_ACADEMIC_YEARS](state, payload) {
    state.catalog.academicYears = payload;
  },
  [MUTATION_TYPES.SET_MONTHS](state, payload) {
    state.catalog.months = payload;
  },
  [MUTATION_TYPES.SET_CENTERS](state, payload) {
    state.catalog.centers = payload;
  },
  [MUTATION_TYPES.SET_SERVICES](state, payload) {
    state.catalog.services = payload;
  },
  [MUTATION_TYPES.SET_SPECIALIST](state, payload) {
    state.catalog.specialists = payload;
  },
  [MUTATION_TYPES.SET_STUDENT](state, payload) {
    state.filter.results = payload.certificationSummaryDetails;
    state.filter.specialistInfo = {
      name: state.filter.specialist ? state.filter.specialist.name : '',
      pendingTotal: 0,
      succeedTotal: 0,
      ...payload,
    };

    state.filter.resultsChunked = payload.certificationSummaryDetails;
    state.filter.resultsData = payload.certificationSummaryDetails;

    //set initial paging
    state.paging = {
      count: state.configPaginated.pageSize,
      currentPage: 1,
      pageCount: payload.certificationSummaryDetails.length,
      totalItemCount: payload.certificationSummaryDetails.length,
    };
  },
  [MUTATION_TYPES.SET_PAGING](state, payload) {
    state.paging = payload;
    state.filter.resultsData =
      state.filter.resultsChunked[payload.currentPage - 1];
  },
  [MUTATION_TYPES.SET_CERTIFICATION_SUMMARY](state, payload) {
    state.filter.results = payload;
  },
  [MUTATION_TYPES.SET_CLEAR_CATALOG](state, payload) {
    state.catalog = {
      ...state.catalog,
      ...payload,
    };
  },
  [MUTATION_TYPES.SET_UPLOADED_STATUS](state, payload) {
    state.filter.specialistInfo = {
      name: state.filter.specialist ? state.filter.specialist.name : '',
      pendingTotal: state.filter.specialistInfo.pendingTotal,
      succeedTotal: state.filter.specialistInfo.succeedTotal,
      totalStudent: state.filter.specialistInfo.totalStudent,
      errorMessages: payload.errorMessages,
      errorDocumentCount: payload.errors,
    };
  },
  [MUTATION_TYPES.SET_DOCUMENT_TYPES](state, payload) {
    state.catalog.documentTypes = payload;
  },
  [MUTATION_TYPES.SET_THERAPY_DOCUMENTS_TYPES](state, payload) {
    state.catalog.therapyDocumentTypes = payload;
  },
  [MUTATION_TYPES.SET_SPECIALIST_OR_COMPANY](state, specialistsOrCompanies) {
    state.catalog.specialistsOrCompanies = specialistsOrCompanies;
  },
};
